import React, { useState, useEffect } from "react"; 
import Cookies from "js-cookie";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button"; 
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment"; 
import Visibility from "@mui/icons-material/Visibility"; 
import { Slide, toast } from "react-toastify"; 
import { 
  IconButton, 
  Autocomplete, 
} from "@mui/material";
import "../../../style/setup.css"; 

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 14,
  padding: "5px 10px",
  border: "1px solid",
  width: "fit-content",
  height: "100%",
  lineHeight: 1.5,
  backgroundColor: "#069DAE",
  fontFamily: ["Roboto"].join(","),
  "&:hover": {
    backgroundColor: "#0696A6",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

export function StorePanelCell({
  editedData,
  setEditedData,
  selectedKodeOutletEdit,
  selectedPanelEdit,
  editModalOpen,
  isLoading,
  setIsLoading,
  handleModalStoreMasterSpecific,
  handleCloseEditModal,
}) {
  const accessToken = Cookies.get("access_token") || "";
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const [dataPanel, setDataPanel] = useState([]);
  const [dataAreaCellEdit, setDataAreaCellEdit] = useState([]);
  const [dataStoreTypes, setDataStoreTypes] = useState([]);
  const [dataCellsEdit, setDataCellsEdit] = useState([]);

  const [selectedCellCodeEdit, setSelectedCellCodeEdit] = useState(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchPanel();
      fetchStoreType();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchAreaCellEdit();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [editedData.panel]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchCellEdit();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [editedData.panel, editedData.areacell, editedData.storetypecode]);

  async function fetchPanel() {
    const token = Cookies.get("access_token");

    setDataPanel([]);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/panel` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: item.panel,
          value: item.panel,
        }));
        setDataPanel(newArray);
      } else {
        setDataPanel([]);
      }
    } catch (error) {
      setDataPanel([]);
    }
  }

  async function fetchStoreType() {
    const token = Cookies.get("access_token");

    setDataStoreTypes([]);

    const queryParams = new URLSearchParams();

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/stat/store-type` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const { data } = await response.json();
        const newArray = data.map((item) => ({
          label: `${item.storetypecode} - ${item.storetype}`,
          value: item.storetypecode,
        }));
        setDataStoreTypes(newArray);
      } else {
        setDataStoreTypes([]);
      }
    } catch (error) {
      setDataStoreTypes([]);
    }
  }

  async function fetchAreaCellEdit() {
    if (editedData.panel) {
      const token = Cookies.get("access_token");

      setDataAreaCellEdit([]);

      const queryParams = new URLSearchParams();

      if (editedData.panel) {
        queryParams.append("panel", editedData.panel);
      }

      const queryString = queryParams.toString();
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/stat/areacell` +
        (queryString ? `?${queryString}` : "");

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: `${item.areacell} - ${item.areacelldesc}`,
            value: item.areacell,
          }));
          setDataAreaCellEdit(newArray);
        } else {
          setDataAreaCellEdit([]);
        }
      } catch (error) {
        setDataAreaCellEdit([]);
      }
    }
  }

  async function fetchCellEdit() {
    if (
      editedData.panel &&
      editedData.areacell &&
      editedData.storetypecode !== undefined &&
      editedData.storetypecode !== null
    ) {
      const token = Cookies.get("access_token");

      setDataCellsEdit([]);

      const queryParams = new URLSearchParams();
      queryParams.append("panel", editedData.panel);
      queryParams.append("areacell", editedData.areacell);
      queryParams.append("storetypecode", editedData.storetypecode);

      const queryString = queryParams.toString();
      const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/stat/map/cellcode?${queryString}`;

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.ok) {
          const { data } = await response.json();
          const newArray = data.map((item) => ({
            label: item.cellcode_description,
            value: item.cellcode,
          }));

          if (data.length > 0) {
            const found = data.find(
              (item) => item.cellcode === editedData.cellcode
            );

            setEditedData((prev) => ({
              ...prev,
              cellcode: found ? found.cellcode : data[0].cellcode,
            }));
          } else {
            setEditedData((prev) => ({
              ...prev,
              cellcode: "0",
            }));
          }

          setDataCellsEdit(newArray);
        } else {
          setDataCellsEdit([]);
          setEditedData((prev) => ({ ...prev, cellcode: "0" }));
        }
      } catch (error) {
        setDataCellsEdit([]);
      }
    }
  }

  const selectedCellEdit = dataCellsEdit.find(
    (item) => item.value === editedData.cellcode
  );

  async function fetchCellByCellcodeEdit(cellcode) {
    if (cellcode === "0" || cellcode === "") {
      setSelectedCellCodeEdit("Tidak diproses");
      return;
    }

    const token = Cookies.get("access_token");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/v1/stat/map/cellcode?cellcode=${cellcode}`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        const { data } = await response.json();
        if (data.length > 0) {
          setSelectedCellCodeEdit(data[0].cellcode_description);
        } else {
          setSelectedCellCodeEdit("Diproses");
        }
      } else {
        setSelectedCellCodeEdit("Diproses");
      }
    } catch (error) {
      setSelectedCellCodeEdit("Diproses");
    }
  }

  const handleUpdateData = async () => {
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    queryParams.append("update_data_processing", true);

    const queryString = queryParams.toString();

    if (selectedKodeOutletEdit && selectedPanelEdit) {
      const token = Cookies.get("access_token");
      const apiUrl =
        `${process.env.REACT_APP_API_URL}/api/v1/stat/store-panel-cell/${selectedKodeOutletEdit}/${selectedPanelEdit}` +
        (queryString ? `?${queryString}` : "");

      try {
        const response = await fetch(apiUrl, {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(editedData),
        });

        if (response.status === 200) {
          toast.success("Data berhasil diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
          handleCloseEditModal();
        } else if (response.status === 404) {
          const apiUrlCreate =
            `${process.env.REACT_APP_API_URL}/api/v1/stat/store-panel-cell` +
            (queryString ? `?${queryString}` : "");

          const createResponse = await fetch(apiUrlCreate, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(editedData),
          });

          if (createResponse.status === 201 || createResponse.ok) {
            toast.success("Data berhasil dibuat!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Slide,
            });
            handleCloseEditModal();
          } else {
            const errorData = await createResponse.json();
            toast.error(errorData.detail || "Gagal membuat data!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Slide,
            });
          }
        } else if (response.status === 400 || response.status === 403) {
          const data = await response.json();
          toast.error(data.detail || "Data gagal diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else if (response.status === 422) {
          toast.error("Data gagal diproses!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else {
          const data = await response.json();
          toast.error(data.detail || "Terjadi kesalahan!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        }
      } catch (error) {
        console.error(error);
        toast.error("Terjadi kesalahan jaringan!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    }
    setIsLoading(false);
  };

  return (
    <div className="edit-data">
      <div>
        <TextField
          label="KODE OUTLET"
          name="kodeoutlet"
          value={editedData.kodeoutlet}
          onChange={(e) =>
            setEditedData({
              ...editedData,
              kodeoutlet: e.target.value,
            })
          }
          sx={{ width: "100%", mb: 2 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle store id visibility"
                  onClick={handleModalStoreMasterSpecific}
                  edge="end"
                >
                  <Visibility />
                </IconButton>
              </InputAdornment>
            ),
          }}
          disabled
          InputLabelProps={{
            shrink: true,
          }}
        />
        <Autocomplete
          options={dataPanel}
          getOptionLabel={(option) => option.label}
          value={
            dataPanel.find((option) => option.value === editedData.panel) ||
            null
          }
          onChange={(event, newValue) => {
            setEditedData({
              ...editedData,
              panel: newValue ? newValue.value : "",
            });
          }}
          sx={{ mb: 2 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="PANEL"
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          disableClearable
          disabled
        />
        <Autocomplete
          options={dataAreaCellEdit}
          getOptionLabel={(option) => option.label}
          value={
            dataAreaCellEdit.find(
              (option) => option.value === editedData.areacell
            ) || null
          }
          onChange={(event, newValue) => {
            setEditedData({
              ...editedData,
              areacell: newValue ? newValue.value : "",
            });
          }}
          sx={{ mb: 2 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="AREA CELL"
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          disableClearable
        />
        <Autocomplete
          options={dataStoreTypes}
          getOptionLabel={(option) => option.label}
          value={
            dataStoreTypes.find(
              (option) => option.value === editedData.storetypecode
            ) || null
          }
          onChange={(event, newValue) => {
            setEditedData({
              ...editedData,
              storetypecode: newValue ? newValue.value : "",
            });
          }}
          sx={{ mb: 2 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="STORE TYPE STAT"
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          disableClearable
        />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            label="CELL CODE"
            name="cellcode"
            value={editedData.cellcode}
            onChange={(e) => {
              const value = e.target.value;
              setEditedData({
                ...editedData,
                cellcode: value,
              });

              if (debounceTimeout) clearTimeout(debounceTimeout);

              const timeout = setTimeout(() => {
                fetchCellByCellcodeEdit(value);
              }, 1000);
              setDebounceTimeout(timeout);
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: "29%", mb: 2 }}
          />
          <TextField
            label="CELL CODE DESCRIPTION"
            name="cellcode_description"
            value={
              selectedCellEdit
                ? selectedCellEdit.label
                : selectedCellCodeEdit || "Tidak diproses"
            }
            disabled
            InputLabelProps={{
              shrink: true,
            }}
            sx={{ width: "69%", mb: 2 }}
          />
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="outlined"
          disableRipple
          sx={{
            width: 190,
            height: 50,
            mt: 2,
            color: "#b34469",
            borderColor: "#b34469",
          }}
          onClick={handleCloseEditModal}
        >
          Cancel
        </Button>
        <BootstrapButton
          variant="contained"
          disableRipple
          sx={{ width: 190, height: 50, mt: 2, mr: 0, ml: 2 }}
          onClick={handleUpdateData}
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "UPDATE"}
        </BootstrapButton>
      </div>
    </div>
  );
}
